export const formatNumber = (number: number) => {
  return number.toLocaleString("en-US", { minimumFractionDigits: 2 });
};
